@if (!isMobile$) {
  <ng-container *ngTemplateOutlet="accountMenu" />
}

@if (isMobile$) {
  <sd-dropdown
    dropdownCustomClass="dropdown-custom-class2"
    dropdownCustomId="navigationAccount"
    (buttonSize)="buttonSize = $event"
  >
    <ng-container sd-dropdown-button>
      {{activeLink}}
    </ng-container>
    <div sd-dropdown-menu [style.width.px]="buttonSize">
      <ng-container *ngTemplateOutlet="accountMenu" />
    </div>
  </sd-dropdown>
}

<ng-template #accountMenu>
  <ul sdUpDown>
    @for (link of links; track link.linkName) {
      <li
        #listLink
        (keydown.enter)="triggerChild(listLink)"
        tabindex="0"
        class="c__option"
      >
        <sd-link
          [link]="link"
          activeClass="is-active"
          (clicked)="linkSelected(link?.linkName)"
        >
          <span>{{ link?.linkName }}</span>
        </sd-link>
      </li>
    }
    @if (loyaltyClub && !isMobile$) {
      <li class="c__club">
        <sd-title
          customClass="brand--h5 is-bold"
          [titleLevel]="loyaltyClub?.titleLevel ? loyaltyClub?.titleLevel : 4"
        >
          {{loyaltyClub?.title}}
        </sd-title>
        <sd-banner [media]="loyaltyClub?.media" />
      </li>
    }
  </ul>
</ng-template>
